import { callApiToServer } from "../callApi";

export async function changeStatus(authtoken, subCategoryId, status) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      sub_category_id: subCategoryId,
      is_active: status,
    });

    let endUrl = "v1/auth/admin/sub-category/active-status-sub-category";

    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "PUT", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
